import { render, staticRenderFns } from "./mailfileinfo-list.vue?vue&type=template&id=3e98135c&"
import script from "./mailfileinfo-list.vue?vue&type=script&lang=js&"
export * from "./mailfileinfo-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mailfileinfo-list.vue"
export default component.exports